interface FloorType {
	code: string;
	name: string;
	spaceOnLevelOptions: number[];
}

const floors: FloorType[] = [
	{ code: "single", name: "Single Floor", spaceOnLevelOptions: [] },
	{ code: "duplex", name: "Duplex", spaceOnLevelOptions: [1, 2] },
	{ code: "triplex", name: "Triplex", spaceOnLevelOptions: [1, 2, 3] },
];

export default floors;
